import { useEffect } from "react";

// Llama onLock tras N minutos sin interacción del usuario.
// Eventos que cuentan como actividad: touch, click, keydown.
// Si timeoutMinutes <= 0, no se activa (deshabilitado).
export function useAutoLock(
  timeoutMinutes: number,
  onLock: () => void,
): void {
  useEffect(() => {
    if (timeoutMinutes <= 0) return;
    let timer: number | undefined;

    const reset = () => {
      if (timer !== undefined) window.clearTimeout(timer);
      timer = window.setTimeout(onLock, timeoutMinutes * 60 * 1000);
    };
    reset();

    const events: Array<keyof DocumentEventMap> = [
      "mousedown",
      "touchstart",
      "keydown",
    ];
    events.forEach((e) => document.addEventListener(e, reset));
    return () => {
      if (timer !== undefined) window.clearTimeout(timer);
      events.forEach((e) => document.removeEventListener(e, reset));
    };
  }, [timeoutMinutes, onLock]);
}
